import { render, staticRenderFns } from "./ClassificationPanel.vue?vue&type=template&id=46957068&scoped=true&"
import script from "./ClassificationPanel.vue?vue&type=script&lang=js&"
export * from "./ClassificationPanel.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationPanel.vue?vue&type=style&index=0&id=46957068&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46957068",
  null
  
)

export default component.exports